import { Box, Button, Card, CardContent, Container, Divider, Grid, Paper, Stack, Typography, styled, useMediaQuery } from '@mui/material'
import { useStyles } from '@styles'
import mylioLogo from '@assets/Mylio Photos+.png'
import imgOne from '@assets/unsplash_LQ1t-8Ms5PY.png'
import imgTwo from '@assets/universal-library_image.png'
import imgThree from '@assets/screenshot_mylio.png'
import timelineImage from '@assets/timeline-image.png'
import storageImage from '@assets/storage-image.png'
import findCommandImage from '@assets/find-command.png'
import editingToolbarImage from '@assets/editing-toolbar.png'
import learnPanelImage from '@assets/learn-panel-image.png'
import spacesImage from '@assets/spaces-image.png'
import workflowImage from '@assets/workflow-image.png'
import familyHistoryImage from '@assets/family-history-image.png'
import frameProjectImage from '@assets/frame-project-image.png'
import viewbugImage from '@assets/viewbug-image.png'
import safeDeleteImage from '@assets/safe-delete.png'
import quickFilterImage from '@assets/quickFilters-image.png'
import bannerImage from '@assets/banner.png'
import { useEffect } from 'react';


const Item = styled(Paper)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const News = () => {

  const isBig = useMediaQuery(`(min-width:700px)`)
  const classes = useStyles()

  useEffect(() => {
    document.body.classList.add('news-layout')
    return () => {
      document.body.classList.remove('news-layout')
    }
  }, [])


  const profileCard = (
    <>
      <CardContent sx={{ backgroundColor: "#f5f5f5", width: isBig ? "300px" : "67vw", padding: "20px", borderRadius: "10px", justifyContent: "center", textAlign: "center" }}>
        <img
          src={imgOne}
          alt="placeholder image"
        />

        <Typography variant="h5" component="div" color="#000" fontWeight={'600'} sx={{ mb: 2, mt: 1.5 }}>Concierge</Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 2, md: 2 }} className='tag-container'>
          <Typography sx={{ mb: 1.5, backgroundColor:'#F9FAFD' }} className={classes.tags} fontSize={'13px'}>Small Bussinesses</Typography>
          <Typography sx={{ mb: 1.5, backgroundColor:'#F9FAFD' }} className={classes.tags} fontSize={'13px'}>Hobbyist</Typography>
        </Stack>

        <Typography variant="body2" color="#000">
          For those who don’t have time to do it themselves or seek mentorship on their journey.
        </Typography>
      </CardContent>
  
    </>
  );
  
  const serviceDescription = (
    <>
      <CardContent>
        {/* <Typography sx={{ fontSize: isBig? '34px' : '21px', fontWeight: 'bold' }} color="#000" gutterBottom>
          One-on-One Services
        </Typography> */}
        <Typography variant="h5" component="div" color="#000"  sx={{ fontSize: '16px', mt:3.5, mb:3 }}>
          Three one-hour sessions | $280 <span style={{textDecoration: 'line-through'}}>$450</span>
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="#000">
          We have a network of Photo Managers with Varying specialties such as:
        </Typography>
        <Stack direction='row' spacing={3} color="#000" className='tag-container' sx={{ display: 'inline' }}>
          <Typography className={classes.tags}>Cataloging scanned media</Typography>
          <Typography  className={classes.tags}>Mixed media libraries</Typography>
          <Typography  className={classes.tags}>Customized syncing</Typography>
          <Typography  className={classes.tags}>Shared accounts for work or family</Typography>
          <Typography  className={classes.tags}>Multi-layered backups</Typography>
          <Typography  className={classes.tags}>Small businesses</Typography>
        </Stack>
      </CardContent>
  
    </>
  );


 return (
  
  <>
  <Stack sx={{ height:'100vh', py: isBig ? `1vh` : `3vh`, paddingLeft: isBig? `0`:`92px`, paddingRight: isBig? `0`:`74px`, overflow: `auto`}} >


    <Stack direction="column" justifyContent={`center`} sx={{ px: isBig? `13vw` : `0vw`, margin: '0 auto' }}>
      <img
        src={bannerImage}
        alt="placeholder image"
        width={'100%'}
        style={{ margin: '0 auto', marginTop:'20px', marginBottom: '20px' }}
      />
      <Typography sx={{ mb: 5, mt: 3.5, fontSize: isBig ? '48px !important' : '33px !important', fontWeight: 'bold' }} color="#000" variant='h3'>
        What’s new in Mylio Photos 24.3
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'} sx={{ paddingBottom: '10px' }}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px' }}>
          <img
            src={storageImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', marginBottom: '20px', paddingTop: '0px' }} color="#000" variant='h5'>
            Storage Panel
          </Typography>
          <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'>
            The new Storage Panel is here to make it easier to control the storage on each device in your account.  
            With it you can understand exactly what is stored on your current device as well adjust the sync settings or remotely access the current file.
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important' }} href="https://manual.mylio.com/topic/understanding-the-storage-panel">Learn More</Button>
        </Stack>

      </Stack>

      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />
      
      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingBottom: '10px' }}>
          <img
            src={findCommandImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', marginBottom: '20px'}} color="#000" variant='h5'>
            Find Command
          </Typography>
          <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'>
          We’ve added a new method to locate just what you’re looking for… it’s called Find.  This method looks in the current page or container you are browsing and attempts to find matches.
          <ul>
            <li>On mobile/tablet – Click the More menu in the upper right corner (…) and choose Find.</li>
            <li>On a computer – Press Cmd+F (macOS) or Ctrl+F (Windows).</li>
          </ul>
          
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important'  }} href="https://manual.mylio.com/topic/using-the-find-command-in-mylio-photos">Learn More</Button>
        </Stack>



      </Stack>

      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />


      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px'}}>
        <Stack >
          <img
            src={editingToolbarImage}
            alt="placeholder image"
            width={'100%'}
          />
        </Stack>
          <Typography sx={{ fontWeight: '700', marginBottom: '20px', marginTop: '20px'}} color="#000" variant='h5'>
            Editing Toolbar
          </Typography>
          <Typography sx={{ mb: 2, mt: '0px !important'  }} color="#000" variant='body1'>
            This new toolbar, strategically positioned on the right-hand side of the screen, offers instant access to essential features like Auto Enhance, Auto Color, and Auto Tone. 
            These tools are specifically engineered to handle common photo issues, such as washed-out colors, white balance problems, and exposure discrepancies.

            <ul>
              <li><b>AutoEnhance</b> – Brightens and increases color – perfect for photos with unnatural lighting</li>
              <li><b>AutoColor</b> - Fixes color balance issues - perfect for photos with unnatural lighting</li>
              <li><b>AutoTone</b> - Fixes exposure and contrast issues - bringing life back to underexposed or overly washed-out images</li>
            </ul>

          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important'  }} href="https://manual.mylio.com/topic/edit-improve-images">Learn More</Button>
        </Stack>

        

      </Stack>


      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />

      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

      
        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingBottom: '10px' }}>
          <img
            src={learnPanelImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', marginBottom: '20px'}} color="#000" variant='h5'>
            Learn Panel
          </Typography>
          <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'>
            Welcome to a whole new way of learning and getting support right within your Mylio Photos application! 
            The Learn Panel is designed to make mastering Mylio Photos both easy and enjoyable, 
            whether you're a new or a seasoned user looking for deeper insights. 
            Just click the book icon in the lower right corner of the desktop interface or from the More menu on mobile.
          
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important'  }} href="https://manual.mylio.com/topic/learn-panel">Learn More</Button>
        </Stack>

      </Stack>

      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />


      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingBottom: isBig ? '20px' : '20px'  }}>
          <img
            src={spacesImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', marginBottom: '20px'}} color="#000" variant='h5'>
            Spaces
          </Typography>
          <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'>
          We are excited to announce several important updates to the Spaces feature. These updates enhance the management of device visibility and functionality, making your digital life more organized, secure, and personalized.

            <ul>
              <li><b>Spaces Templates</b> – Now, setting up a space  is easier with customizable presets that simplify the user experience. These changes allow you to assign specific access to devices, perfect for shared devices at home or work.</li>
              <li><b>Customization at Your Fingertips</b> - Mylio Photos+ users can create and manage their custom spaces. Whether it's for individual projects or shared devices, you can control what is visible and accessible in each space. Now when you disable access to a tool or permission, the function is truly hidden. </li>
            </ul>

          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important'  }} href="https://manual.mylio.com/topic/manage-spaces">Learn More</Button>
        </Stack>

      </Stack>

      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />

      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>
        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingBottom: '10px' }}>
          <img
            src={workflowImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', marginBottom: '20px' }} color="#000" variant='h5'>
            Workflows
          </Typography>
          <Typography sx={{ mb: 5, mt: '2px !important'  }} color="#000" variant='body1'>
            Workflows are designed to make your interaction with Mylio Photos more intuitive and less cluttered. 
            By focusing only on the tools you need for a particular task, Workflows reduce complexity and enhance user-friendliness. 
            This targeted approach helps both new and seasoned users find the necessary tools without distraction, promoting a more efficient and pleasant photo management experience.
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important'  }} href="https://manual.mylio.com/topic/working-with-categories">Learn More</Button>
        </Stack>

        


      </Stack>
      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />

      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingBottom: '10px' }}>
          <img
            src={familyHistoryImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', marginBottom: '0px', marginTop: '10px'  }} color="#000" variant='h5'>
            Family History Improvements
          </Typography>
          <Typography color="#000">
            <ul>
              <li><b>Family History Category: </b> Quickly categorize your images with a tap. This default category makes it easier to filter and find your historical content without the need for custom tags. </li>
              <li><b>Family History Space: </b> This dedicated space within Mylio Photos is tailored for users focused on family history. It displays only your family history photos, making it easier to browse through and organize your archival materials. Whether you're preparing to share these memories with relatives or simply ensuring they are preserved for posterity, this space provides a focused environment to work with your historical images.</li>
              <li><b>Family History eBook: </b> <a href="https://media2-production.mightynetworks.com/asset/cad91ea0-f30a-405b-b0b9-a6dbad91c362/FamilyHistory_eBook_v1.pdf"> DOWNLOAD — FamilyHistory_eBook_v1.pdf</a> </li>
            </ul>
          </Typography>

        </Stack>

      </Stack>
      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />
      <Stack direction={{ xs: 'column' }} textAlign={'left'} sx={{ paddingBottom: '10px'}}>

          <img
            src={frameProjectImage}
            alt="placeholder image"
            width={'100%'}
          />
       
        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px' }}>
          <Typography sx={{ fontWeight: '700', marginBottom: '20px', paddingTop: '20px' }} color="#000" variant='h5'>
            Frame.io Project Watcher
          </Typography>
          <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'>
            This release introduces a new option – the Frame.io Project Watcher adds your project to Mylio Photos as a series of watched folders where all newly added assets will be periodically added to your Mylio Photos Library.
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important'  }} href="https://manual.mylio.com/topic/import-from-frame-io">Learn More</Button>
        </Stack>

      </Stack>
      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0'}} />

      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingBottom: '10px', paddingTop: isBig ? '0px' : '40px'  }}>
          <img
            src={viewbugImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', paddingTop: '0px' }} color="#000" variant='h5'>
            Post to VIEWBUG
          </Typography>
          <Typography color="#000" sx={{ marginTop: '0px' }}>
            You’ll find a new publishing tool in Mylio Photos – the ability to post to VIEWBUG.  
            The platform is a great way to explore creativity and receive recognition. 
            You’ll find photo contests, photo challenges, portfolio websites, photography logos, and 
            photography classes giving photographers tools to be creative and showcase their art. 
            Exporting images from Mylio Photos is simple and can be done with just a few clicks from your computer or mobile device.
            
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important'  }} href="https://manual.mylio.com/topic/post-to-viewbug">Learn More</Button>
          {/* <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', marginTop: '30px !important', margin: '0 auto !important'  }} href="https://manual.mylio.com/topic/post-to-viewbug">Learn More</Button> */}
        </Stack>

      </Stack>

      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '40px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />

      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingTop: '30px' }}>
          <img
            src={safeDeleteImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', marginBottom: '20px', paddingTop: '20px' }} color="#000" variant='h5'>
            Safe Delete
          </Typography>
          <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'>
            If a file is deleted in your file system (i.e., macOS Finder or Windows Explorer), Mylio Photos+ can attempt to restore it from a Vault device. This setting can be customized for each device on your account individually.
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px', margin: '0 auto !important', marginTop: '30px !important'  }} href="https://manual.mylio.com/topic/understanding-safe-delete">Learn More</Button>
        </Stack>

      </Stack>
      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '20px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />
      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingBottom: isBig ? '10px' : '20px', paddingTop: isBig ? '50px' : '50px' }}>
          <img
            src={quickFilterImage}
            alt="placeholder image"
            width={'100%'}
          />
          <Typography sx={{ fontWeight: '700', marginBottom: '10px', paddingTop: '0px' }} color="#000" variant='h5'>
            Modification of QuickFilters
          </Typography>
          <Typography color="#000">
            Mylio Photos’ QuickFilters help you quickly find specific photos, videos, and documents by narrowing your browsing results based on specific criteria. 

            <ol type="1">
              <li>Right-click or long-press on an existing filter pill in the top bar</li>
              <li>
                Different choices will be available depending on the type of filter and its current status.
                <ul>
                  <li><b>Include – </b>This option is used to filter based on items that match it.</li>
                  <li><b>Exclude – </b>This option is used to show items that do not match the criteria.</li>
                  <li><b>Pin Filter – </b>Convert a filter to a pinned state to stack another from the same group with it</li>
                  <li><b>Remove Filter – </b>Subtract the filter from the current recipe</li>
                </ul>
              </li>
            </ol>
          </Typography>

        </Stack>

      </Stack>

      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />

      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', paddingBottom: isBig ? '0px' : '40px' }}>
          <Typography sx={{ fontWeight: '700' }} color="#000" variant='h5'>
            Other Improvements
          </Typography>
          <Typography color="#000">
          Thank you for the feedback in our community and forum.  We also appreciate those of you who take the time to contact support.  We've addressed the following areas of performance for a better experience.

            <ul>
              <li><b>Update Messaging if your machine stops syncing. </b> If your machine stops syncing for an extended period of time, you may now see a warning banner,  This lets you troubleshoot any issues with your Mylio Photos+ account and ensures your devices stay in proper sync with each other.</li>
              <li><b>Remove Visual Stack Effect. </b>Previously there was a visual effect applied to people, folders, and albums.  This effect slowed down the user interface and redraw times.  The ability to use a swipe or mouse scroll to flutter through the containers contents is not affected by the change.</li>
              <li><b>Improve Visibility of Info Panel Tabs.</b> We’ve improved the contrast ratio of the Info panel tabs to meet accessibility standards.  You can also choose whether to hide the Sync panel or the new Storage panel for a minimal interface. </li>
              <li><b>Expanded Location Fields for All.</b> Originally introduced as part of our Family History mode at the request of the Family History Metadata Workgroup, several additional location fields were added to the Mylio Photos Info panel. </li>
              <li><b>Ability to opt out of SmartTag Search.</b> For users with very large libraries (or those who don’t like assisted organization) you can disable SmartTags from being shown in the Search results. </li>
              <li><b>Face Tagging Improvements. </b>
                  <ol>
                    <li><b>Retain Current Face switching views when Face Tagging.</b> When you switch from the current person into a single image, the active person remains targeted in the full photo for tagging.</li>
                    <li><b>Keep Consistent Face Tag Counts Across Platforms.</b> We’ve improved the consistency of the face tag counts across platforms when syncing multiple devices with Mylio Photos+. For the most accurate counts, disable the Auto-Tagging feature.</li>
                    <li>Several other face tagging performance issues and UI inconsistencies have also been addressed.</li>
                  </ol>
              </li>
              <li><b>Improved S3 Compatibility.</b> Certain servers had difficulty connecting to Mylio Photos. We’ve improved the compatibility of S3 servers. </li>
              <li><b>Improved Photo Explorer.</b> Quickly See other photos of a person. If you click in the Photo Explorer, you’ll see details for a person in the picture.  If you synced an address book to the person in People view, you can easily share photos with that person.  A new addition is the ability to click on a person’s icon to see additional photos with them. </li>
            </ul>
          
          </Typography>
        </Stack>

      </Stack>
      <Divider orientation="horizontal" variant="middle" flexItem sx={{ marginBottom: '60px', marginTop: '50px', borderColor: '#ddd', marginLeft: '0', marginRight: '0' }} />

      <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

        <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px', marginBottom: '70px'}}>
          <Typography sx={{ fontWeight: '700', marginBottom: '0px' }} color="#000" variant='h5'>
            New Camera Support
          </Typography>
          <Typography color="#000">
            We’re pleased to support raw files now from:

            <ul>
              <li>OM System OM-1 Mark II</li>
              <li>Fujifilm X100VI</li>
              <li>Support crop mode on the Sony a7CR</li>
              <li>Improved decoding for several Fujifilm raw formats</li>
            </ul>
          
          </Typography>
        </Stack>

      </Stack>

      
    </Stack>
    

      
      {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 2, md: 2, lg:4 }} sx={{ px: isBig? `13vw` : `0vw` }}>
        <Typography sx={{ fontWeight: '700', marginBottom: '30px' }} color="#000" variant='h4'>
          One-on-One Services
        </Typography>
        <Stack>
          {profileCard}
        </Stack>
        <Stack sx={{ paddingLeft: isBig? `60px` : `0`  }}>
          {serviceDescription}
        </Stack>
      </Stack> */}

      {/* <Stack direction="column" justifyContent={`center`} sx={{ px: isBig? `13vw` : `0vw`, margin: '0 auto', paddingBottom: isBig ? '60px' : '0px'  }}>

        <Typography sx={{ mb: 1.5, mt: 10, fontSize: '40px', fontWeight: 'bold' }} color="#000" variant='h3'>
          What can they help you with?
        </Typography>
        
        <Typography sx={{ mb: 5, fontSize: '24px', fontWeight: '700' }} color="#000" variant='h1'>
          Some of the things our Photo Managers specialize in
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={'left'}>

          <Stack justifyContent={'center'} spacing={{sm: 1, md:4}} sx={{ paddingLeft: isBig? '0px' : '0px' }}>
            <Typography sx={{ fontWeight: '700' }} color="#000" variant='body1'>
              Catalog scanned media
            </Typography>
            <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'>
            Catalog scanned media for easy browsing and searching, integrated with your digital media.
            </Typography>

            <Typography sx={{ fontWeight: '700' }} color="#000" variant='body1'>
              Customized syncing
            </Typography>
            <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'>
            Configure syncing for each device, ensuring you only have the desired content on each one.
            </Typography>


            <Typography  sx={{  fontWeight: '700',  }} color="#000" variant='body1'>
              Multi-layered backups
            </Typography>
            <Typography sx={{ mb: 3, mt: '0px !important'  }} color="#000" variant='body1'> 
              Establish a multi-layered backup process that includes hard drives, NAS, computers, tablets, smartphones, and cloud accounts.
            </Typography>
          </Stack>

          <Stack sx={{ paddingTop: '60px', paddingLeft: isBig ? '60px' : '12px', paddingRight: isBig ? '60px' : '0px' }}>
            <img
              src={imgTwo}
              alt="placeholder image"
              width={'100%'}
            />
          </Stack>

        </Stack>

        

   
     

      </Stack>  */}

{/* 
      <Stack direction={{ xs: 'column', sm: 'column' }} justifyContent={`center`} sx={{ px: isBig? `13vw` : `0vw` , margin: '0 auto' }}>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing="2" textAlign={'left'} >

          <Stack sx={{ paddingTop: '60px', paddingRight: isBig ? '80px': '0' }}>
            <img
              src={imgThree}
              alt="placeholder image"
              width={'100%'}
            />
          </Stack>

          <Stack justifyContent={'center'}>
            <Typography sx={{ fontWeight: '700' }} color="#000" variant='body1'>
              Mixed-media libraries
            </Typography>
            <Typography sx={{ mb: 3 }} color="#000" variant='body1'>
            Create a seamless system for cataloging and searching across various file types.
            </Typography>

            <Typography sx={{ fontWeight: '700' }} color="#000" variant='body1'>
              Shared accounts
            </Typography>
            <Typography sx={{ mb: 3  }} color="#000" variant='body1'>
            Setup multiple accounts for collaboration with family, friends, or colleagues. Control over what you share.
            </Typography>

            <Typography sx={{ fontWeight: '700' }} color="#000" variant='body1'>
              Small businesses
            </Typography>
            <Typography sx={{ mb: 3 }} color="#000" variant='body1'>
            Businesses that handle a significant amount of media. Typically for creative, marketing, collaboration, or archival purposes.
            </Typography>
          </Stack>

      </Stack> */}

    {/* </Stack> 

      <Stack direction="column" justifyContent={`center`} sx={{  margin: '0 auto', backgroundColor: '#FBFCFE', mb:6, mt:6 }}>
        <Typography sx={{ mb: 1.5, mt:5, fontSize: '34px', fontWeight: '700', textAlign: 'left', px: isBig? `13vw` : `0vw` }} color="#000" variant='h1' >
          What should you expect?
        </Typography>
        
          <Stack sx={{ paddingLeft:isBig? '65px' : '0', py: isBig? '50px' : '0'}}>
            <img
              src={timelineImage}
              alt="placeholder image"
              width={'100%'}
            />
          </Stack>
        

      </Stack>



      <Typography sx={{ mb: 3, mt:5, fontSize: '34px', fontWeight: '700', textAlign: 'left', pl: isBig? `13vw` : `0vw` }} color="#000" variant='h1'>
        Want to learn more before commiting?
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{xs:1, sm:1, lg:2}} textAlign={"left"} sx={{ px: isBig? `10vw` : `0`}}>
        
        <Stack sx={{ padding: isBig? '50px': '10px' }}>
          <Typography sx={{ mb: 1.5, fontWeight: '700' }} color="#000" variant='h5'>
            Chat with us          
          </Typography>
          <Typography variant='body1' color="#000" sx={{ mb:3, mt:.5 }} >
            Connect with a live member of our team through the chat bubble at the bottom of your browser window. 
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px' }} href="#">Chat Now</Button>
        </Stack>

        <Stack sx={{ padding: isBig? '50px': '10px' }}>
          <Typography sx={{ mb: 1.5, fontWeight: '700' }} color="#000" variant='h5'>
            Use Mylio Photos today         
          </Typography>
          <Typography variant='body1' color="#000" sx={{ mb:3, mt:.5 }}>
            All yearly subscriptions come with a free 30 minute set up session. See how that works for you before trying out more. 
          </Typography>
          <Button variant="outlined" target='_blank' sx={{ color: "#0E9AF1", borderColor:"#0E9AF1", backgroundColor: "#fff", maxWidth: '200px' }} href="#">Subscribe</Button> 
        </Stack>
      </Stack> */}

    

  </Stack>
  </>
 )
}
export default News